import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout.vue'
import {solutionApi,productApi} from '@/api/index.js'
import store from '../store'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
//解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    //console.log("VueRouter.prototype.push",err)
  })
}

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页' }
      },
      // {
      //   path: 'productlist',
      //   name: "ProductList",
      //   component: () => import('@/views/products/ProductsList.vue'),
      //   meta: { title: '产品列表' },
      //   children: [
      //     {
      //       path: 'category/:cat1',
      //       name: 'ProductsCategory',
      //       component: () => import('@/views/products/ProductsCategory.vue'),
      //       meta: { title: '分类' }
      //     },
      //     {
      //       path: 'detail/:id?',
      //       name: 'Detail',
      //       component: () => import('@/views/products/ProductsDetail.vue'),
      //       meta: { title: '产品详情' }
      //     },
      //     {
      //       path: 'productsIndex',
      //       name: 'ProductsIndex',
      //       component: () => import('@/views/products/ProductsIndex.vue'),
      //       meta: { title: '产品中心' }
      //     },

      //     {
      //       path: ':cat1/:cat2',
      //       name: 'ProductsList',
      //       component: () => import('@/views/products/ProductsList.vue'),
      //       meta: { title: '产品列表' }
      //     },
      //   ]
      // },
      {
        path: 'products',
        name: "Products",
        component: () => import('@/views/products/index.vue'),
        redirect: "products/index",
        meta: { title: '产品中心' },
        children: [
          {
            path: 'index',
            name: "Product",
            component: () => import('@/views/products/ProductsIndex.vue'),
            meta: { title: '产品中心' },
          },
          {
            path: 'productdetail',
            name: "ProductDetail",
            component: () => import('@/views/products/ProductsDetail.vue'),
            // meta: { title: '产品详情' },
            // beforeEnter: async (to, from, next) => {
            //   try {
            //     const data = await productApi.getProductDetail(to.query.id)
            //     to.meta.data = data
            //     to.meta.title = data.name 
            //     next();
            //   }catch(error){
            //     next(false);  // 阻止导航
            //     console.error('Error fetching data:', error);
            //   }
            // }
          },
          {
            path: 'category',
            name: "ProductCategoryList",
            component: () => import('@/views/products/ProductCategoryList.vue'),
            // beforeEnter: async (to, from, next) => {
            //   try {
            //     const data = await productApi.getProductCategoryById(to.query.id)
            //     to.meta.data = data
            //     to.meta.title = data.name 
            //     next();
            //   }catch(error){
            //     next(false);  // 阻止导航
            //     console.error('Error fetching data:', error);
            //   }
            // }
          },
          {
            path: 'productlist',
            name: "ProductList",
            component: () => import('@/views/products/ProductsList.vue'),
            // beforeEnter: async (to, from, next) => {
            //   try {
            //     const data = await productApi.getProductCategoryById(to.query.id)
            //     to.meta.data = data
            //     to.meta.title = data.name 
            //     next();
            //   }catch(error){
            //     next(false);  // 阻止导航
            //     console.error('Error fetching data:', error);
            //   }
            // }
            // beforeEnter: async (to, from, next) => {
            //   try {
                
            //     //console.log("=========================路由变化================================")
            //     //console.log(to, from)
            //     const data = await Api.productApi.getProductCategoryById(to.query.id)
            //     to.meta.currentCategory = data;  
            //     //console.log("==========1  ",to.meta )
            //     if (!to.query.childId) {
            //       to.meta.currChildCategory =await store.state.productCategorys.filter(async item =>item.id === to.query.childId )[0]
            //     } else {
            //       to.meta.currChildCategory = data
            //     }
                
            //     //console.log("========== 2 ",to.meta )
            //     to.meta.childrenCategory =await store.state.productCategorys.filter(async item =>item.parentId === to.query.id )
                
            //     //console.log("========== 3 ",to.meta )
            //     // //console.log("data", data)
            //    // 将数据存储在路由元信息中
            //     next();
            //   } catch (error) {
            //     next(false);  // 阻止导航
            //     console.error('Error fetching data:', error);
            //   }
            // }
          },
        ],

      },
      {
        path: 'news',
        name: 'News',
        component: () => import('@/views/news/index.vue'),
        meta: { title: '新闻中心' },
        redirect: "news/index",
        children: [
          {
            path: 'index',
            name: "NewsIndex",
            component: () => import('@/views/news/News.vue'),
            meta: { title: '新闻中心' },
          },
          {
            path: 'detail',
            name: "NewsDetail",
            component: () => import('@/views/news/NewsDetail.vue'),
          //  meta: { title: '解决方案详情' },
          }]
      },
      {
        path: 'productused',
        name: 'Productused',
        component: () => import('@/views/Productused.vue'),
        meta: { title: '产品应用' }
      },
      {
        path: 'solutions',
        name: 'Solutions',
        component: () => import('@/views/solutions/index.vue'),
        meta: { title: '解决方案' },
        redirect: "solutions/index",
        children: [
          {
            path: 'index',
            name: "Solution",
            component: () => import('@/views/solutions/Solutions.vue'),
            meta: { title: '解决方案' },
          },
          {
            path: 'category',
            name: "SolutionCategoryList",
            component: () => import('@/views/solutions/Category.vue'),
            // beforeEnter: async (to, from, next) => {
            //   const data = await solutionApi.getSolutionCategoryById(to.query.id)
            //   to.meta.title =data.name 
            //   next();
            // }
          },
          {
            path: 'detail',
            name: "SolutionDetail",
            component: () => import('@/views/solutions/SolutionDetail.vue'),
          //  meta: { title: '解决方案详情' },
          }]
      },
      {
        path: 'services',
        name: 'Services',
        component: () => import('@/views/services/index.vue'),
        meta: { title: '服务支持' },
        redirect: "services/index",
        children: [
          {
            path: 'index',
            name: "Service",
            component: () => import('@/views/services/Service.vue'),
            meta: { title: '服务支持' },
          }]
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/views/About.vue'),
        meta: { title: '关于我们' }
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('@/views/Contact.vue'),
        meta: { title: '联系我们' }
      },
      {
        path: 'search',
        name: 'Search',
        component: () => import('@/views/Search.vue'),
        meta: { title: '全站检索' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
    return savedPosition;
    } else {
    return { x: 0, y: 0 };
    }
    }

})
/** 解决跳转重复路由报错问题 */ 
// const routerPush = router.push;
// router.push = path => {
//   // 判断下当前路由是否就是要跳转的路由
//   if (router.currentRoute.fullPath.includes(path)) return;
//   return routerPush.call(router, path);
// }
export const isSameRoute = (route1, route2) => {
  return route1.path === route2.path &&
         route1.name === route2.name &&
         JSON.stringify(route1.params) === JSON.stringify(route2.params) &&
         JSON.stringify(route1.query) === JSON.stringify(route2.query)
}

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 西安夏溪电子科技有限公司` : '西安夏溪电子科技有限公司'
  if (isSameRoute(to, from)) {
    //console.log('阻止重复导航到:', to.path)
    return next(false)
  }
  next()

})


export default router 